import type { ObjectDirective } from "vue";

type ClickAwayHandler = (ev: MouseEvent) => void;

interface ClickAwayElement extends HTMLElement {
   listenerClick?: (ev: MouseEvent) => void;
}

export const clickAway: ObjectDirective<ClickAwayElement, ClickAwayHandler> = {
   getSSRProps() {
      return {};
   },
   mounted(el) {
      if (el.listenerClick) {
         window.addEventListener("click", el.listenerClick, false);
      }
   },
   beforeMount(el, binding, vnode) {
      el.listenerClick = (ev: MouseEvent) => {
         const path = (ev as MouseEvent & { path?: EventTarget[] }).path
            || (ev.composedPath ? ev.composedPath() : undefined);
         if (path ? path.indexOf(el) < 0 : !el.contains(ev.target as Node)) {
            if (!binding.value) {
               throw new Error("Missing a binded method");
            }
            return binding.value.call(binding.instance, ev);
         }
      };
   },
   beforeUnmount(el) {
      if (el.listenerClick) {
         window.removeEventListener("click", el.listenerClick);
      }
   },
};
